import { type Clip, ClipType } from '@air/api/types';
import { ClipUtils } from '@air/utils-clips';

import { getAddToCanvasMenuState } from './canAddClipsToCanvas';

/**
 * Whether this clip can be placed on a canvas as an image or video node.
 * Video-to-GIF conversion is capped at 30s / 500MB; opening a video node is not.
 */
export const clipCanOpenInCanvas = (clip: Clip) => {
  if (clip.type === ClipType.video) {
    return !ClipUtils.isProcessing(clip.status);
  }

  return getAddToCanvasMenuState([clip]).canAdd;
};
